module.exports = __webpack_public_path__ + "static/img/h8-5.11c0a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h8-5.png
// module id = ptAf
// module chunks = 1